export default ({ 
  percentage: percentageRaw = 0, 
  size = 50, 
  color = "#018a53",
  direction = ''
}) => {
  const percentage = Number.isFinite(Number(percentageRaw)) ? percentageRaw : 0; // ensure non number strings are set to 0
  const strokeWidth = (size * 0.24); // 12 is default value for a size of 50
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: direction === 'row' ? 'row' : "column",
        alignItems: "center",
        justifyContent: 'center'
      }}
    >
      <svg 
        width={size} 
        height={size}
        style={{
          // rotate to 12 o’clock & flip to counterclockwise
          transform: "rotate(-90deg) scale(1, -1)",
        }}
      >
        <circle
          stroke="#fff"
          fill="transparent"
          strokeWidth={strokeWidth}
          cx={size / 2}
          cy={size / 2}
          r={radius}
        />
        <circle
          stroke={color}
          fill="transparent"
          strokeWidth={strokeWidth}
          // strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          cx={size / 2}
          cy={size / 2}
          r={radius}
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div
        style={{
          fontWeight: "bold",
          color,
          marginTop: direction === 'row' ? "0px" : "10px",
          marginLeft: '10px' // percentage ? "10px" : '0px'
        }}
      >
        {percentage ? `${percentage}%` : 'N/A'}
      </div>
    </div>
  );
};
